import { Flex } from '@applyboard/crystal-ui';

import { GradeConversionCreateHeading } from '../components/GradeConversionCreateHeading';
import { GradeConversionCreateForm } from '../components/GradeConversionCreateForm';
import { GradeConversionCreateLayoutProps } from './types';

export function TabletLayout(props: GradeConversionCreateLayoutProps) {
  return (
    <Flex p={6} gap={6} direction="column">
      <GradeConversionCreateHeading />
      <GradeConversionCreateForm {...props} />
    </Flex>
  );
}
